import React, { useState } from 'react';
import './Form.css';
import {login} from '../../redux/actions/userAction'
import {connect} from 'react-redux'
import { useHistory } from 'react-router-dom';
import CustomButton from '../../constants/CustomButton';
import {Redirect} from 'react-router-dom';

function Form(props) {
	const [InputEmail, setInputEmail] = useState('');
	const [InputPassword, setInputPassword] = useState('');
	const [isLoading,setIsLoading]=useState(false)
	const history = useHistory();

	const handleEmailChange = (e) => {
		setInputEmail(e.target.value);
	};

	const handlePasswordChange = (e) => {
		setInputPassword(e.target.value);
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		setIsLoading(true)
		props.login({email:InputEmail,password:InputPassword});
		setIsLoading(false)

	};
	const token = localStorage.getItem("token");
	if(!!token) return <Redirect to="/dashboard"/>
	return (
		<div className='right_container'>
			<center>
				<h3 className='form-header bold'>Welcome to XYZ</h3>
			</center>
			<form className='form-container' onSubmit={handleSubmit}>
				<label for='InputEmail' className='form-label'>
					Username or Email
				</label>
				<br />
				<center>
					<input
						style={{width:400}}
						id='InputEmail'
						className='form-input'
						onChange={handleEmailChange}
					/>
				</center>
				<br />
				<br />
				<label for='InputPassword' className='form-label'>
					Password
				</label>
				<br />
				<center>
					<input
						style={{width:400}}
						type='password'
						id='InputPassword'
						className='form-input'
						onChange={handlePasswordChange}
					/>
					<br />
				</center>
				<p className='forgot-password text-right'>
					<small>
						
					</small>
				</p>
				<center>
				
					<CustomButton type="submit" label="Sign in" isloading={isLoading}/>
				</center>
			</form>
		</div>
	);
}
const mapActionWithProps = {
	login
}

export default connect(null,mapActionWithProps)(Form)
